```vue
<template>
  <div class="grid-container">
    <!-- Header with Filter Icon -->
    <div class="toggle-header">
      <h3>Сургалтууд</h3>
      <button class="toggle-btn" @click="toggleSidebar">
        <i :class="isSidebarHidden ? 'fa fa-filter' : 'fa fa-times'"></i>
      </button>
    </div>
    <!-- Lessons Container -->
    <div class="lessons-container">
      <div class="sidebar-wrapper" :class="{ hidden: isSidebarHidden }">
        <SidebarMenu
          :items="lessonTypes"
          :activeType="selectedType"
          @update-type="onTypeChange"
        />
      </div>

      <!-- Main Content: Lesson List -->
      <div class="lesson-list">
        <div v-if="lessonData.length > 0" class="row row-grid">
          <LessonCard
            v-for="course in lessonData"
            :key="course.id"
            :data="course"
            :userType="'other'"
          />
        </div>
        <p v-else>Хичээл олдсонгүй.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LessonCard from "./../components/lesson/LessonCard.vue";
import SidebarMenu from "./../components/lesson/SidebarMenu.vue";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
  name: "Lessons",
  components: {
    LessonCard,
    SidebarMenu,
  },
  data() {
    return {
      lessonData: [],
      lessonTypes: [],
      selectedType: "", // tracks the currently selected type value (parent or sub-type)
      isSidebarHidden: false, // tracks sidebar visibility
    };
  },
  methods: {
    fetchLessonData() {
      if (!this.lessonTypes.length) return;

      let params = { skip: 0, limit: 100 };
      if (this.selectedType && this.selectedType !== "all") {
        params.lesson_type = this.selectedType;
      }

      axios
        .get("/lessons", { params })
        .then((response) => {
          this.lessonData = response.data.items || [];
          if (this.$route.query.type !== this.selectedType) {
            this.$router
              .replace({ query: { type: this.selectedType } })
              .catch((err) => {
                if (err.name !== "NavigationDuplicated") {
                  console.error("Router replace error:", err);
                }
              });
          }
        })
        .catch((err) => {
          console.error("Error fetching lessons:", err);
        });
    },
    onTypeChange(newType) {
      this.selectedType = newType;
      this.fetchLessonData();
    },
    async fetchTypeDetails() {
      try {
        const response = await axios.get(`/lessons/types`);
        this.lessonTypes = [...response.data];

        // Get selected type from URL (if exists)
        const urlType = this.$route.query.type;
        if (urlType) {
          for (let i = 0; i < this.lessonTypes.length; i++) {
            const parent = this.lessonTypes[i];
            if (parent.value === urlType) {
              this.selectedType = urlType;
              break;
            } else if (parent.childs && parent.childs.length) {
              const child = parent.childs.find((child) => child.value === urlType);
              if (child) {
                this.selectedType = child.value;
                break;
              }
            }
          }
        } else {
          this.selectedType = this.lessonTypes[0].value || "";
        }

        this.fetchLessonData();
      } catch (error) {
        console.error("Failed to load lesson details", error);
      }
    },
    toggleSidebar() {
      this.isSidebarHidden = !this.isSidebarHidden;
    },
  },
  created() {
    this.fetchTypeDetails();
  },
};
</script>

<style scoped>
.grid-container {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.toggle-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
}

.toggle-btn {
  display: none; /* Hidden by default */
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #333;
  transition: color 0.3s;
}

.toggle-btn:hover {
  color: #007bff;
}

.lessons-container {
  display: grid;
  grid-template-columns: 25% 75%;
  gap: 20px;
  padding: 20px;
}

.sidebar-wrapper.hidden {
  display: none;
}

.lesson-list {
  display: flex;
  flex-direction: column;
}

.row-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

/* Tablet screens (max-width: 768px) */
@media (max-width: 768px) {
  .grid-container {
    padding: 10px;
  }

  .toggle-header {
    padding: 0 10px;
  }

  .toggle-btn {
    display: block; /* Show button on tablet */
    font-size: 1.1rem;
  }

  .lessons-container {
    grid-template-columns: 1fr; /* Stack sidebar and content vertically */
    padding: 10px;
  }

  .sidebar-wrapper {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px;
  }

  .lesson-list {
    margin-top: 20px;
  }

  .row-grid {
    justify-content: center;
    gap: 10px;
  }
}

/* Mobile screens (max-width: 480px) */
@media (max-width: 480px) {
  .grid-container {
    padding: 10px;
  }

  .toggle-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 10px;
  }

  .toggle-btn {
    display: block; /* Show button on mobile */
    font-size: 1rem;
  }

  .lessons-container {
    padding: 5px;
  }

  .sidebar-wrapper {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 8px;
  }

  .row-grid {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  h3 {
    font-size: 1.2rem;
  }
}
</style>
```